import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function EditDocument({
  color = 'icon.primary',
  strokeWidth = '1.5',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 21 21' {...props}>
      <Path
        d='M8.75 16.625H4.1125C3.29088 16.625 2.625 15.9285
           2.625 15.0693V4.18075C2.625 3.3215 3.29088 2.625
            4.1125 2.625H16.0125C16.8341 2.625 17.5 3.3215
             17.5 4.18075V7.875'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
      <Path
        d='M7.875 6.125H13.125'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
      <Path
        d='M6.125 9.625H13.125'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
      <Path
        d='M6.125 13.125H8.75'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.1314 18.1186L18.9936 14.2563C19.3358 13.9142
           19.3358 13.3603 18.9936 13.0191L17.6059 11.6313C17.2638
            11.2892 16.7099 11.2892 16.3686 11.6313L12.5064
             15.4936C12.3419 15.6581 12.25 15.8803 12.25
              16.1122V18.375H14.5128C14.7446 18.375 14.9669
               18.2831 15.1314 18.1186V18.1186Z'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </IconBase>
  )
}

EditDocument.propTypes = {
  color: PropTypes.string,
  strokeWidth: PropTypes.string,
  fill: PropTypes.string,
}

export default EditDocument
